import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { URLS } from '../config';
import { MenuType } from '../types';

interface UseGetMenuReturn {
  menu: MenuType[];
  menuLoading: boolean;
  error: unknown;
}

export const useGetMenu = (): UseGetMenuReturn => {
  const { data: menu = [], isLoading: menuLoading, error } = useQuery<MenuType[], Error>({
    queryKey: ['menu'],
    queryFn: async (): Promise<MenuType[]> => {
      const response = await axios.get<MenuType[]>(URLS.GET_MENU);
      return response.data;
    },
    // Data is considered fresh for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Refetch when window gains focus
    refetchOnWindowFocus: true,
    // Refetch when network reconnects
    refetchOnReconnect: true,
  });

  return { menu, menuLoading, error };
};
